<template>
  <v-dialog v-model="dialog" max-width="900">
    <!-- SK스페셜티 보안 서약서 -->
    <v-card v-if="cPledgeId == 'A0001'">
      <v-card class="pl-4 pr-4 education_make_scroll" flat>
        <v-card-title class="education_title" id="A0001">
          <div class="red--text text--darken-2 education_title_text">보안 서약서 동의</div>
          <v-spacer></v-spacer>
          <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
        </v-card-title>
        <v-divider class="mb-2"></v-divider>

        <v-card-text class="education_content lineHeight2" flat>
          <div class="mb-4">
            {{$store.state.CustomInfo.SiteNm}} 주식회사(이하 "회사"라 함)를 출입하는 데서 다음의 정보보호에 관한 내용에 동의하며, 상호신뢰 하에 성실히 준수할 것을 서약합니다.
          </div>
          <div v-for="item in oSecPeldge" :key="item.cId" class="d-flex text_first_font mt-1">
            <div>{{item.cId}}&nbsp;</div>
            <div>{{item.cComment}}</div>
          </div>
        </v-card-text>


        <v-divider></v-divider>    
        <v-card-text class="education_content lineHeight2">
          본인은 상기 사항을 숙지하였으며, 성실히 준수할 것을 서약합니다. 만일 상기 사항을 위반할 경우 회사의 사규에 따른 어떠한 조치도 감수할 것이며, 관련법률에 따른 민·형사상 책임 및 회사에 발생한 모든 손해에 대한 배상 책임을 부담하겠습니다.
        </v-card-text>

        <v-card-text class="greeting_date text-center">
          {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
        </v-card-text>
        <v-card-text class="greeting_title text-center">
          {{$store.state.CustomInfo.SiteNm}} 주식회사 귀중
        </v-card-text>
      </v-card>

      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-actions class="pr-4 pl-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn width="100" @click="dialog = false;" dark class=""><v-icon>mdi-close</v-icon>닫기</v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-if="cPledgeId == 'A0002'">
      <v-card class="pl-4 pr-4 education_make_scroll" flat>
        <v-card-title class="education_title lineHeight2" id="A0002">
          <div class="red--text text--darken-2 education_title_text">개인정보 수집 및 이용 동의서</div>
          <v-spacer></v-spacer>
          <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
        </v-card-title>
        <v-divider class="mb-2"></v-divider>

        <v-card-text class="education_content lineHeight2">
          {{$store.state.CustomInfo.SiteNm}} 주식회사(이하 '회사'라고 함)는 개인정보와 관련된 정보통신망 이용 촉진 및 정보보호 등에 관한 법률(이하 '정보통신망법') 및 개인정보보호에 관한 법률(이하 '개인정보 보호법') 등을 준수합니다. 개인정보 처리에 대한 상세한 사항은 개인정보 처리 방침을 참고하여 주시기를 바랍니다.
          
          <div class="mt-6 education_content" style="color:black;">
            <div class="d-flex">
              <div>1.&nbsp;</div>
              <div>
                개인정보의 수집 및 이용<br>
                <table class="type09 text-center">
                  <thead>
                    <tr>
                      <th scope="cols"></th>
                      <th scope="cols"></th>
                      <th scope="cols"></th>
                    </tr>
                  </thead>
                  <tbody class="text_first_font">
                    <tr>
                      <td>수집 목적</td>
                      <td>수집 항목</td>
                      <td>보유 및 이용 기간</td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-felx">
                          1)&nbsp;홈페이지 회원가입, 운영 및 유지보수
                        </div>
                        <!-- <div class="d-flex">
                          1)&nbsp;
                          <div>홈페이지 회원가입, 운영 및 유지보수</div>
                        </div> -->
                        <br>
                        <div class="d-flex">
                          2)&nbsp;
                          <div>공장 출입 통제 및 관리 운영</div>
                        </div>
                      </td>
                      <td>성명, 비밀번호, 연락처, 회사명, 사업자등록번호, 회사 주소, 직급, 사진</td>
                      <td>회원 탈퇴 후 1년간 별도 보관 후 삭제, 또는 정보 주체의 개인정보 삭제 요청 시까지</td>
                    </tr>
                  </tbody>
                </table>
                <div class="pl-4 mt-4 mb-4 text_first_font">
                  이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 정보 주체로부터 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. 다만, 정보 주체로부터 동의받은 개인정보 보유 기간이 경과하거나, 처리 목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관 장소를 달리하여 보존합니다.
                </div>
              </div>
            </div>


            <div class="d-flex mb-1">
              2.&nbsp;
              <div>
                개인 영상정보의 수집 및 이용<br>
                <div class="mt-1 mb-2 text_first_font">
                  회사는 개인정보 보호법 제25조 1항에 따라 다음과 같은 목적으로 영상정보처리기기를 설치하여 개인 영상정보를 수집 및 관리하고 있습니다.<br>
                  <div class="d-flex mb-2 mt-4">
                    1)&nbsp;
                    <div>
                      이용목적<br>
                      시설 안전 및 화재 예방<br>
                      정보 주체의 안전을 위한 범죄 예방<br>
                      외부인 불법침입 방지<br>
                      차량 도난 및 파손 방지<br>
                      (※ 주차장의 경우 「주차장법 시행규칙」 제6조 제1항을 근거로 설치·운영)
                    </div>
                  </div>
                  <div class="d-flex mb-2">
                    <div>2)&nbsp;</div>
                    <div>
                      보유 및 이용 기간<br>
                      -촬영일로부터 1개월간 보관 후 삭제
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex mb-1">
              3.&nbsp;
              <div>
                개인정보의 위탁 및 제 3자 제공
                <div class="mt-1 mb-2 text_first_font">
                  회사는 서비스 이행을 위해 아래와 같이 개인정보를 위탁하고 있으며 제 3자 제공은 하지 않습니다. 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.
                  <div class="mt-4 mb-2 text_first_font">
                    <div class="d-flex mb-2">
                      <div>1)&nbsp;</div>
                      <div>
                        출입 방문시스템 운영<br>
                        위탁받는 자(수탁자) : M4<br>
                        위탁하는 업무의 내용<br>
                        - 홈페이지 운영 및 유지보수
                      </div>
                    </div>
                    <div class="d-flex mb-2">
                      <div>2)&nbsp;</div>
                      <div>
                        출입 통제 및 관리, 영상정보처리기기 운영<br>
                        위탁받는 자(수탁자) : 캡스텍<br>
                        위탁하는 업무의 내용<br>
                        <div class="d-flex mb-1">
                          <div>-&nbsp;</div>
                          <div>공장 출입을 위한 출입자 신원 확인 등의 출입 통제, 관리 운영</div>
                        </div>
                        <div class="d-flex mb-1">
                          <div>-&nbsp;</div>
                          <div>화재, 범죄 예방을 위해 공장 주요 도선, 외곽에 설치한 영상정보처리기기 운영 및 비상 상황 대응 활동 등</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex mb-2">
              4.&nbsp;
              <div>
                동의 거부 권리 및 동의 거부 시 불이익 내용<br>
                <div class="mt-1 mb-2 text_first_font">
                  귀하는 위와 같은 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부할 경우에는 출입 방문시스템({{HomepageURL}}) 사이트의 회원가입을 할 수 없으며 출입증 발급 및 회사 출입이 불가능합니다.
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-actions class="pr-4 pl-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn width="100" @click="dialog = false;" dark><v-icon>mdi-close</v-icon>닫기</v-btn>
      </v-card-actions>
    </v-card>


    <!-- 위치정보 수집 및 이용 동의서 -->
    <v-card v-if="cPledgeId == 'A0003'">
      <v-card class="pl-4 pr-4 education_make_scroll" flat>
        <v-card-title class="education_title" id="A0003">
          <div class="red--text text--darken-2 education_title_text">위치정보 수집 및 이용 동의서</div>
          <v-spacer></v-spacer>
          <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
        </v-card-title>
        <v-divider class="mb-2"></v-divider>

        <v-card-text class="education_content lineHeight2">
          당사를 출입하는 데 출입자 관리상 개인정보 제공이 필요하다는 것을 이해하고 있으며 이를 위해 '개인정보 보호법' 등의 관련 법률에 따라 당사가 아래의 개인정보를 수집·이용하는 것에 추가 동의합니다.<br>
          당사가 제공하고 있는 공장 내에서 패용하여야 하는 “Smart Tag”는 주기적으로 위치정보를 송신하는 장치이며, 당사는 “Smart Tag”를 통하여 공장 내에서 귀하의 개인 위치 정보를 수집합니다.<br>
          <div class="red--text mt-6">[필수]</div><br>
          <table class="type09 text-center mb-6">
            <thead>
            <tr>
              <th scope="cols" class="pt-0"></th>
              <th scope="cols" class="pt-0"></th>
              <th scope="cols" class="pt-0"></th>
              <th scope="cols" class="pt-0"></th>
            </tr>
            </thead>
            <tbody class="text_first_font">
              <tr>
                <td>수집 항목</td>
                <td>수집 방법</td>
                <td>수집·이용목적</td>
                <td>보유 및 이용 기간</td>
              </tr>
              <tr>
                <td>위치정보</td>
                <td>Smart Tag (블루투스)</td>
                <td>안전</td>
                <td>수집일로부터 1년</td>
              </tr>
            </tbody>
          </table>
          <div class="red--text">[선택]</div><br>
          <table class="type09 text-center">
            <thead>
              <tr>
                <th scope="cols" class="pt-0"></th>
                <th scope="cols" class="pt-0"></th>
                <th scope="cols" class="pt-0"></th>
                <th scope="cols" class="pt-0"></th>
            </tr>
            </thead>
            <tbody class="text_first_font">
              <tr>
                <td>수집 항목</td>
                <td>수집 방법</td>
                <td>수집·이용목적</td>
                <td>보유 및 이용 기간</td>
              </tr>
              <tr>
                <td>위치정보</td>
                <td>Smart Tag (블루투스)</td>
                <td>방문객의 출입 위규 분석</td>
                <td>수집일로부터 1년, 다만 정보 주체의 출입 보안 관련 위규 사항이 적발되었을 때는 그로부터 사건 처리 종료 시까지</td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>

      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-actions class="pr-4 pl-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn width="100" @click="dialog = false;" dark><v-icon>mdi-close</v-icon>닫기</v-btn>
      </v-card-actions>
    </v-card>
    <!-- <v-card v-if="cPledgeId == 'A0003'" id="A0003" class="pa-4">
      <v-card class="mt-n4" min-height="520" flat>
        <v-card-title>
          <div class="text-h4 red--text text--darken-2">위치정보 수집 및 이용 동의서</div>                
          <v-spacer></v-spacer>
          <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height:45px"/>
        </v-card-title>
        <v-divider class="mb-2"></v-divider>
        <v-card-text class="text-subtitle-2 lineHeight2 ma-4">
          당사를 출입하는 데 출입자 관리상 개인정보 제공이 필요하다는 것을 이해하고 있으며 이를 위해 '개인정보 보호법' 등의 관련 법률에 따라 당사가 아래의 개인정보를 수집·이용하는 것에 추가 동의합니다.<br>
          당사가 제공하고 있는 공장 내에서 패용하여야 하는 “Smart Tag”는 주기적으로 위치정보를 송신하는 장치이며, 당사는 “Smart Tag”를 통하여 공장 내에서 귀하의 개인 위치 정보를 수집합니다.<br>
        </v-card-text>
        <v-divider class="mb-2"></v-divider>
        <v-card-text class="text-subtitle-1 font-weight-bold lineHeight2">
          <strong class="red--text">[필수]</strong><br>
        </v-card-text>
        <table class="type09 text-center">
          <thead>
          <tr>
            <th scope="cols"></th>
            <th scope="cols"></th>
            <th scope="cols"></th>
            <th scope="cols"></th>
          </tr>
          </thead>
          <tbody class="text-subtitle-2">
            <tr>
              <td>수집 항목</td>
              <td>수집 방법</td>
              <td>수집·이용목적</td>
              <td>보유 및 이용 기간</td>
            </tr>
            <tr>
              <td>위치정보</td>
              <td>Smart Tag (블루투스)</td>
              <td>안전</td>
              <td>수집일로부터 1년</td>
            </tr>
          </tbody>
        </table>
        <v-card-text class="text-subtitle-1 font-weight-bold lineHeight2">
          <strong class="red--text">[선택]</strong><br>
        </v-card-text>
        <table class="type09 text-center">
          <thead>
            <tr>
              <th scope="cols"></th>
              <th scope="cols"></th>
              <th scope="cols"></th>
              <th scope="cols"></th>
          </tr>
          </thead>
          <tbody class="text-subtitle-2">
            <tr>
              <td>수집 항목</td>
              <td>수집 방법</td>
              <td>수집·이용목적</td>
              <td>보유 및 이용 기간</td>
            </tr>
            <tr>
              <td>위치정보</td>
              <td>Smart Tag (블루투스)</td>
              <td>방문객의 출입 위규 분석</td>
              <td>수집일로부터 1년, 다만 정보 주체의 출입 보안 관련 위규 사항이 적발되었을 때는 그로부터 사건 처리 종료 시까지</td>
            </tr>
          </tbody>
        </table>
        <v-card-text align="right" class="pa-0 pt-2">
          <v-btn width="100" @click="dialog = false;" dark><v-icon>mdi-close</v-icon>닫기</v-btn>
        </v-card-text>
      </v-card>   
    </v-card> -->


    <v-card v-if="cPledgeId == 'A0004'">
      <v-card class="pl-4 pr-4 education_make_scroll" flat>
        <v-card-title class="education_title" id="A0004">
          <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
          <v-divider vertical class="hidden-md-and-up ml-2 mr-2 mx-2"></v-divider>
          <v-divider vertical class="hidden-sm-and-down ml-5 mr-5"></v-divider>
          <div class="red--text text--darken-2 education_title_notitext">{{$store.state.CustomInfo.SiteNm}} 보안 교육 서약</div>
        </v-card-title>
        <v-divider class="mb-2"></v-divider>
        <v-card-text class="education_content lineHeight4">
          본인은 정해진 기간 내에 귀사를 출입하는 데 사전에 <strong>허가된</strong> 업무만을 수행하고 귀사의 <strong>보안 규정을</strong> 준수하겠으며, 위 사항을 숙지하여 반드시 이행할 것을 <strong>서약</strong>합니다.<br>
        </v-card-text>
      </v-card>

      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-actions class="pr-4 pl-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn width="100" @click="dialog = false;" dark><v-icon>mdi-close</v-icon>닫기</v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-if="cPledgeId == 'A0005'">
      <v-card class="pl-4 pr-4 education_make_scroll" flat>
        <v-card-title class="education_title" id="A0005">
          <div class="education_title_text red--text text--darken-2">환경안전사고 예방 서약서</div>
          <v-spacer></v-spacer>
          <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
        </v-card-title>
        <v-divider class="mb-2"></v-divider>
        <v-card-text v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" class="education_content text-center lineHeight4 mt-5 mb-5">
          본인은 {{$store.state.CustomInfo.SiteNm}}의 <strong class="font-weight-black">S.G.R 10대 항목</strong>을 충분히 이해하고<br>{{$store.state.CustomInfo.SiteNm}}의 환경안전사고 예방에 적극 실천할 것을 서약합니다. <br>또한 위반 시 Penalty 사항에 대한 징계 의뢰에 동의합니다.
        </v-card-text>  
        <v-card-text v-else class="education_content text-center lineHeight4 mt-5 mb-5">
          본인은 {{$store.state.CustomInfo.SiteNm}}의 <strong class="font-weight-black">S.G.R 8대 항목</strong>을 충분히 이해하고<br>{{$store.state.CustomInfo.SiteNm}}의 환경안전사고 예방에 적극 실천할 것을 서약합니다. <br>또한 위반 시 Penalty 사항에 대한 징계 의뢰에 동의합니다.
        </v-card-text>    
        <v-divider></v-divider>
        <div v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" class="ma-10 hidden-xs-only">
          <v-card-text class="education_content lineHeight4">
            <div class="d-flex">1.&nbsp;<div>화학물질 취급/작업 時 지정된 보호구 착용</div></div>
            <div class="d-flex">2.&nbsp;<div>사고보고 기준 준수</div></div>
            <div class="d-flex">3.&nbsp;<div>작업 時 작업허가서 승인 후 작업</div></div>
            <div class="d-flex">4.&nbsp;<div>밀폐작업 時 산소농도/유해가스 측정</div></div>
            <div class="d-flex">5.&nbsp;<div>고소지역 작업 時 추락 예방 조치 후 작업</div></div>
            <div class="d-flex">6.&nbsp;<div>변경 관리 절차 준수</div></div>
            <div class="d-flex">7.&nbsp;<div>지정 된 장소 外 금연</div></div>
            <div class="d-flex">8.&nbsp;<div>사내 운송수단 안전수칙 준수</div></div>
            <div class="d-flex">9.&nbsp;<div>안전장치 임의 해제 금지</div></div>
            <div class="d-flex">10.&nbsp;<div>위험작업 時 2인 1조 작업</div></div>
          </v-card-text>       
        </div>
        <div v-else class="ma-10 hidden-xs-only">
          <v-card-text class="education_content lineHeight4">
            <div class="d-flex">1.&nbsp;<div>유해화학물질 취급/작업 時 지정된 보호구 착용</div></div>
            <div class="d-flex">2.&nbsp;<div>사고 보고 기준 준수 (즉시 보고/서면 보고</div>)</div>
            <div class="d-flex">3.&nbsp;<div>작업 時 작업허가서 승인 후 작업</div></div>
            <div class="d-flex">4.&nbsp;<div>밀폐작업 時 산소농도/유해가스 측정</div></div>
            <div class="d-flex">5.&nbsp;<div>고소지역 작업 時 추락 예방 조치 후 작업</div></div>
            <div class="d-flex">6.&nbsp;<div>변경 관리 절차 준수 (변경검토, 가동 전 점검</div>)</div>
            <div class="d-flex">7.&nbsp;<div>지정 된 장소 外 금역 (라이터 휴대 금지</div>)</div>
            <div class="d-flex">8.&nbsp;<div>사내 운송수단 안전수칙 준수</div></div>
          </v-card-text>       
        </div>
        <div v-if="$store.state.CustomInfo.SiteId == 'SKMG14'" class="ma-4 d-sm-none">
          <v-card-text class="education_content lineHeight4">
            <div class="d-flex">1.&nbsp;<div>화학물질 취급/작업 時 지정된 보호구 착용</div></div>
            <div class="d-flex">2.&nbsp;<div>사고보고 기준 준수</div></div>
            <div class="d-flex">3.&nbsp;<div>작업 時 작업허가서 승인 후 작업</div></div>
            <div class="d-flex">4.&nbsp;<div>밀폐작업 時 산소농도/유해가스 측정</div></div>
            <div class="d-flex">5.&nbsp;<div>고소지역 작업 時 추락 예방 조치 후 작업</div></div>
            <div class="d-flex">6.&nbsp;<div>변경 관리 절차 준수</div></div>
            <div class="d-flex">7.&nbsp;<div>지정 된 장소 外 금연</div></div>
            <div class="d-flex">8.&nbsp;<div>사내 운송수단 안전수칙 준수</div></div>
            <div class="d-flex">9.&nbsp;<div>안전장치 임의 해제 금지</div></div>
            <div class="d-flex">10.&nbsp;<div>위험작업 時 2인 1조 작업</div></div>
          </v-card-text>       
        </div>
        <div v-else class="ma-4 d-sm-none">
          <v-card-text class="education_content lineHeight4">
            <div class="d-flex">1.&nbsp;<div>유해화학물질 취급/작업 時 지정된 보호구 착용</div></div>
            <div class="d-flex">2.&nbsp;<div>사고 보고 기준 준수 (즉시 보고/서면 보고</div>)</div>
            <div class="d-flex">3.&nbsp;<div>작업 時 작업허가서 승인 후 작업</div></div>
            <div class="d-flex">4.&nbsp;<div>밀폐작업 時 산소농도/유해가스 측정</div></div>
            <div class="d-flex">5.&nbsp;<div>고소지역 작업 時 추락 예방 조치 후 작업</div></div>
            <div class="d-flex">6.&nbsp;<div>변경 관리 절차 준수 (변경검토, 가동 전 점검</div>)</div>
            <div class="d-flex">7.&nbsp;<div>지정 된 장소 外 금역 (라이터 휴대 금지</div>)</div>
            <div class="d-flex">8.&nbsp;<div>사내 운송수단 안전수칙 준수</div></div>
          </v-card-text>       
        </div>
        <v-divider></v-divider>
        <v-card-text class="education_content lineHeight2">
          상기 각 항의 내용을 충분히 숙지하였으며, 성실히 준수할 것을 서약합니다.             
        </v-card-text>

        <v-card-text class="d-flex">
          <v-spacer></v-spacer>
          <v-text-field v-model="$store.state.CustomInfo.CustomNm" label="성명" readonly placeholder="성명을 입력하세요." style="max-width:200px"></v-text-field>
        </v-card-text>

        <v-card-text class="greeting_title text-center">
          {{$store.state.CustomInfo.SiteNm}} 대표이사 귀하
        </v-card-text>
      </v-card>

      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-actions class="pr-4 pl-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn width="100" @click="dialog = false;" dark><v-icon>mdi-close</v-icon>닫기</v-btn>
      </v-card-actions>
    </v-card>


    <v-card v-if="cPledgeId == 'A0006'">
      <v-card class="pl-4 pr-4 education_make_scroll" flat>
        <v-card-title class="education_title" id="A0006">
          <div class="red--text text--darken-2 education_title_text">골든룰 패널티 서약서</div>
          <v-spacer></v-spacer>
          <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
        </v-card-title>
        <v-divider class="mb-2"></v-divider>
        
        <v-card-text class="education_content lineHeight2">
          작업자 위반사항 발생 시 <strong class="red--text">경고 없이 즉시 적용</strong><br>                                                
        </v-card-text>

        
        <table class="type09 text-center">
          <thead>
            <tr>
              <th scope="cols">구 분</th>
              <th scope="cols">1차 위반</th>
              <th scope="cols">2차 위반</th>
              <th scope="cols">3차 위반</th>
            </tr>
          </thead>
          <tbody class="text_first_font">
            <tr>
              <td>임직원</td>
              <td>위반자 경고<br>(경위서 제출)</td>
              <td>팀장 경고<br>(해당 직원 조치사항 제출)</td>
              <td>인사(소)위원회 회부</td>
            </tr>
            <tr>
              <td >협력업체<br>직원</td>
              <td>협력업체 안전관리자가 위반자 구두 경고</td>
              <td>[직원] 1개월 공장 출입 금지<br>[회사] 업체 안전관리자 면담</td>
              <td>[직원] 6개월 공장 출입 금지<br>[회사] 업체 대표 면담. SHE 평가 반영</td>
            </tr>
            <tr>
              <td colspan='4' class="text-left">
                <div class="d-flex">※&nbsp;<div>위반 누적 기한 : 발생 시점으로부터 2년</div></div>
                <div class="d-flex">※&nbsp;<div>1항 위반(사내 금연 및 사고 발생 시 S.G.R 위반자는 3차 위반과 동일하게 적용하여 처리</div></div>
                <div class="d-flex">※&nbsp;<div>협력업체 정직원인 경우 협력업체 인사위원회 결정에 따라 출입 금지 해제 검토</div></div>
              </td>
            </tr>
          </tbody>
        </table>
        <v-card-text class="education_content lineHeight2 text-center">                
          Golden Rule 위반 시, 적용되는 Penalty에 대해 <strong class="red--text">동의합니다.</strong>
        </v-card-text>
      </v-card>

      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-actions class="pr-4 pl-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn width="100" @click="dialog = false;" dark><v-icon>mdi-close</v-icon>닫기</v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-if="cPledgeId == 'A0007'" class="pa-4 pt-0 pb-2">
      <v-card flat>
        <v-card-title class="peldge_title pr-0 pl-0" id="A0007">
          <div class="red--text text--darken-2 peldge_title_text">개인정보 처리 방침</div>
          <v-spacer></v-spacer>
          <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
        </v-card-title>
        <v-divider></v-divider>

        <div class="pledge_content">
          <v-card-text class="lineHeight2">
            <div class="content_subtitle">
              <div class="mb-2">{{$store.state.CustomInfo.SiteNm}} 주식회사(이하 '회사'라고 함)는 고객님의 개인정보를 중요시하며, 개인정보와 관련된 정보통신망 이용 촉진 및 정보보호 등에 관한 법률(이하 '정보통신망법') 및 개인정보보호에 관한 법률(이하 '개인정보 보호법'), 위치정보의 보호 및 이용 등에 관한 법률(이하 위치정보법) 등 관련 법령상의 개인정보 보호 규정을 준수하고 있습니다.</div>
              <div class="mb-2">회사는 개인정보 처리 방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도의 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.</div>
              <div class="mb-2">회사는 개인정보 처리 방침을 개정하는 경우 웹사이트 공지사항 또는 개별 공지를 통하여 공지할 것입니다.</div>
              본 방침에 명시하지 않은 사항은 '정보통신망법' , '개인정보 보호법' , '위치정보법' 및 동법 시행령에서 규정한 사항을 따릅니다.
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-text class="lineHeight2">
            <div class="mb-1 d-flex">
              1.&nbsp;
              <div>
                개인정보의 처리 목적
                <div class="content_subtitle mt-2 mb-4">
                  회사는 다음의 목적을 위하여 개인정보를 처리합니다.<br>
                  수집되는 개인정보는 다른 용도로 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 정보 주체로부터 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

                  <div class="mb-1 mt-4 d-flex">
                    1)&nbsp;
                    <div>
                      홈페이지 회원가입, 운영 및 유지보수<br>
                      회원가입 의사 확인, 본인 식별, 회원자격 유지·관리, 서비스 부정 이용 방지, 각종 고지 및 통지 등을 목적으로 개인정보를 처리합니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    2)&nbsp;
                    <div>
                      공장 출입 통제 및 관리 운영<br>
                      공장 내 출입을 위한 방문자 신원확인 등의 출입 통제, 출입증 발급, 보안 규정 준수 확인 등을 목적으로 개인정보를 처리합니다.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              2.&nbsp;
              <div>
                개인정보의 처리 항목 및 보유 기간
                <div class="content_subtitle mt-2 mb-4">
                  '회사'는 법령에 따른 개인정보 보유·이용 기간 또는 정보 주체로부터 개인정보를 수집할 때 동의받은 개인정보 보유·이용 기간 내에서 개인정보를 처리·보유합니다.<br>
                  <table class="type09 text-center mb-4">
                    <thead>
                      <tr>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>수집 방법</td>
                        <td>수집 항목</td>
                        <td>보유 및 이용 기간</td>
                      </tr>
                      <tr>
                        <td>방문예약시스템 회원가입<br></td>
                        <td>성명, 비밀번호, 연락처, 회사명, 사업자등록번호, 회사 주소, 직급, 사진</td>
                        <td>회원 탈퇴 후 1년간 별도 보관 후 삭제, 또는 정보 주체의 개인정보 삭제 요청 시까지</td>
                      </tr>
                    </tbody>
                  </table>
                  다만, 정보 주체로부터 동의받은 개인정보 보유 기간이 경과하거나, 처리 목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관 장소를 달리하여 보존합니다.
                </div>
              </div>
            </div>
            
            <div class="mb-1 d-flex">
              3.&nbsp;
              <div>
                개인정보 처리 위탁
                <div class="content_subtitle mt-2 mb-4">
                  회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.<br>
                  <div class="mt-4">
                    <div class="mb-1 mt-4 d-flex">
                      1)&nbsp;
                      <div>
                        출입 방문시스템 운영<br>
                        위탁받는 자(수탁자) : ㈜엠포컴퍼니<br>
                        위탁하는 업무의 내용<br>
                        <div class="d-flex">-&nbsp;<div>홈페이지 운영 및 유지보수</div></div><br>
                      </div>
                    </div>
                    
                    <div class="mb-1 d-flex">
                      2)&nbsp;
                      <div>
                        출입 통제 및 관리, 영상정보처리기기 운영<br>
                        위탁받는 자(수탁자) : 캡스텍<br>
                        위탁하는 업무의 내용<br>
                        <div class="d-flex mt-2">-&nbsp;<div>공장 출입을 위한 출입자 신원 확인 등의 출입 통제, 관리 운영</div></div>
                        <div class="d-flex mt-2 mb-2">-&nbsp;<div>화재, 범죄 예방을 위해 공장 주요 도선, 외곽에 설치한 영상정보처리기기 운영 및 비상 상황 대응 활동 등</div></div>
                      </div>
                    </div>

                    회사는 위탁계약 체결 시 '개인정보 보호법' 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.<br>
                    위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보 처리 방침을 통하여 공개하도록 하겠습니다.<br>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              4.&nbsp;
              <div>
                개인정보의 제 3자 제공<br>
                <div class="content_subtitle mt-2 mb-4">
                  회사는 원칙적으로 이용자의 동의 없이 이용자의 개인정보를 제 3자에게 제공하지 않습니다. 다만, 다음 각호에 해당하는 경우에는 예외로 합니다.

                  <div class="mt-4 mb-1 d-flex">
                    1)&nbsp;
                    <div>법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우</div>
                  </div>
                  <div class="mb-1 d-flex">
                    2)&nbsp;
                    <div>공공기관이 법령 등에서 정하는 소관 업무의 수행을 위하여 불가피한 경우</div>
                  </div>
                  <div class="d-flex">
                    3)&nbsp;
                    <div>정보 주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 정보 주체 또는 제 3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              5.&nbsp;
              <div>
                개인정보의 파기<br>
                <div class="content_subtitle mt-2 mb-4">
                  회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때는 지체 없이 해당 개인정보를 파기합니다.<br>

                  <div class="mb-1 mt-2 d-flex">
                    1)&nbsp;
                    <div>
                      파기 절차<br>
                      이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정 기간 저장된 후 혹은 즉시 파기됩니다. 이때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
                    </div>
                  </div>
                  <div class="pr-4 pl-4 mb-2">
                  </div>
                  <div class="mb-1 d-flex">
                    2)&nbsp;
                    <div>
                      파기 기한<br>
                      이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    3)&nbsp;
                    <div>
                      파기 방법<br>
                      전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.<br>
                      종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              6.&nbsp;
              <div>
                정보 주체와 법정대리인의 권리·의무 및 행사 방법<br>
                <div class="content_subtitle mt-2 mb-4">
                  <div class="mb-1 d-flex">
                    1)&nbsp;
                    <div>정보 주체는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.</div>
                  </div>
                  <div class="mb-1 d-flex">
                    2)&nbsp;
                    <div>제1항에 따른 권리 행사는 회사에 대해 개인정보 보호법 시행령 제41조 1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체 없이 조치하겠습니다.</div>
                  </div>
                  <div class="mb-1 d-flex">
                    3)&nbsp;
                    <div>제1항에 따른 권리 행사는 정보 주체의 법정 대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 “개인정보 처리 방법에 대한 고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</div>
                  </div>
                  <div class="mb-1 d-flex">
                    4)&nbsp;
                    <div>개인정보 열람 및 처리 정지 요구는 개인정보 보호법 제35조 제5항, 제37조 제2항에 의하여 정보 주체의 권리가 제한될 수 있습니다.</div>
                  </div>
                  <div class="mb-1 d-flex">
                    5)&nbsp;
                    <div>개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</div>
                  </div>
                  <div class="mb-1 d-flex">
                    6)&nbsp;
                    <div>‘회사’는 정보 주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              7.&nbsp;
              <div>
                정보 주체와 법정대리인의 권리·의무 및 행사 방법<br>
                <div class="content_subtitle mt-2 mb-4">
                  회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.<br>
                  <p>쿠키는 웹사이트를 운영하는 데 이용되는 서버가 이용자의 컴퓨터 브라우저에 보내는 소량의 정보이며 이용자의 컴퓨터 하드디스크에 저장됩니다.</p>
                  <div class="mb-1 d-flex">
                    1)&nbsp;
                    <div>쿠키의 사용 목적 : 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용 형태, 보안 접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.</div>
                  </div>
                  <div class="mb-1 d-flex">
                    2)&nbsp;
                    <div>쿠키의 설치•운영 및 거부 : 쿠키 설정을 거부하는 방법으로는 고객이 사용하는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.</div>
                  </div>
                  <p></p>
                  ※ 설정 방법 예<br>
                  (Internet Explorer의 경우) : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 > 고급 > 설정 방법 선택<br>
                  (Chrome의 경우) 웹 브라우저 우측 설정 메뉴 > 도구 > 인터넷 사용기록 삭제<br>
                  (Edge의 경우) 웹 브라우저 우측 설정 메뉴 > 쿠키 및 사이트 권한 > 쿠키 및 사이트 데이터<br>
                  
                  쿠키 저장을 거부할 경우 서비스 이용에 어려움이 발생할 수 있습니다.
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              8.&nbsp;
              <div>
                개인정보보호 책임자 지정<br>
                <div class="content_subtitle mt-2 mb-4">
                  <table class="type08 text-center mb-4">
                    <thead>
                      <tr>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style="background-color:#F2F2F2">
                        <td class="font-weight-bold black--text">구분</td>
                        <td class="font-weight-bold black--text">개인정보보호 책임자</td>
                        <td class="font-weight-bold black--text">개인정보보호 담당자</td>
                      </tr>
                      <tr>
                        <td>성명 / 직급</td>
                        <td>안정훈 / -</td>
                        <td>양주동 / PL</td>
                      </tr>
                      <tr>
                        <td>부서</td>
                        <td>DT담당</td>
                        <td>DT담당</td>
                      </tr>
                      <tr>
                        <td>연락처</td>
                        <td colspan="2">skfam112@sk.com</td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="mb-2 " style="font-weight: 600;" >
                    <div v-if="$store.state.CustomInfo.SiteId == 'SKST'">
                      개인정보담당자 : 윤영남 PL(zeroman0929@sk.com)
                    </div>
                    <div v-if="$store.state.CustomInfo.SiteId == 'SKTC'">
                      개인정보담당자 : 최성호 PRO(HR팀, Sungho.c@sk.com)
                    </div>
                    <div v-if="$store.state.CustomInfo.SiteId == 'SKMG14'">
                      개인정보담당자 : 성병재 PRO(HR팀, qudwo02@sk.com)
                    </div>
                    <div v-if="$store.state.CustomInfo.SiteId == 'SKMJ'">
                      개인정보담당자 : 김대건 PL(사업운영담당, kimgunny@sk.comSK)
                    </div>
                    <div v-if="$store.state.CustomInfo.SiteId == 'SKMP'">
                      개인정보담당자 : 김장원 PL(HR팀, wkddnjs7788@sk.com)
                    </div>
                    <div v-if="$store.state.CustomInfo.SiteId == 'SKMA'">                      
                    </div>
                  </div>

                  회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만 처리, 피해 구제 등에 관한 사항을 개인정보 보호 책임자 및 담당 부서로 문의하실 수 있습니다.
                  개인정보 보호법 제35조에 따른 개인정보의 열람 청구를 하실 수 있습니다. 회사는 정보 주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              9.&nbsp;
              <div>
                개인정보의 안전성 확보 조치<br>
                <div class="content_subtitle mt-2 mb-4">
                  <p>회사는 개인정보 보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 취하고 있습니다.</p>

                  <div class="mb-1 d-flex">
                    1)&nbsp;
                    <div>
                      정기적인 자체 감사 실시<br>
                      개인정보 취급 관련 안정성 확보를 위해 정기적(연 1회)으로 자체 감사를 실시하고 있습니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    2)&nbsp;
                    <div>
                      개인정보 취급 직원의 최소화 및 교육<br>
                      개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화하여 개인정보를 관리하는 대책을 시행하고 있습니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    3)&nbsp;
                    <div>
                      내부 관리계획의 수립 및 시행<br>
                      개인정보의 안전한 처리를 위하여 내부 관리계획을 수립하고 시행하고 있습니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    4)&nbsp;
                    <div>
                      해킹 등에 대비한 기술적 대책<br>
                      회사는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    5)&nbsp;
                    <div>
                      개인정보의 암호화<br>
                      이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화하거나 파일 잠금 기능을 사용하는 등의 별도 보안 기능을 사용하고 있습니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    6)&nbsp;
                    <div>
                      접속기록의 보관 및 위변조 방지<br>
                      개인정보 처리시스템에 접속한 기록을 최소 1년 이상 보관, 관리하고 있으며, 다만 5만 명 이상의 정보 주체에 관하여 개인정보를 추가하거나, 고유 식별정보 또는 민감정보를 처리하는 경우에는 2년 이상 보관, 관리하고 있습니다.<br>
                      또한, 접속기록이 위변조 및 도난, 분실되지 않도록 보안 기능을 사용하고 있습니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    7)&nbsp;
                    <div>
                      개인정보에 대한 접근 제한<br>
                      개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입 차단 시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    8)&nbsp;
                    <div>
                      문서 보안을 위한 잠금장치 사용<br>
                      개인정보가 포함된 서류, 보조 저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    9)&nbsp;
                    <div>
                      비인가자에 대한 출입 통제<br>
                      개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입 통제 절차를 수립, 운영하고 있습니다.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              10.&nbsp;
              <div>
                개인 위치정보의 처리<br>
                <div class="content_subtitle mt-2 mb-4">
                  <p>회사는 위치정보법에 의거하여 개인 위치정보를 수집 시 별도 동의를 받고 있습니다.</p>
                  ○ 개인 위치정보 수집 항목 : Smart Tag를 패용한 방문객의 위치정보<br>
                  ○ 개인 위치정보 수집 방법 : Smart Tag(블루투스)<br>
                  ○ 개인 위치정보 처리목적 : 방문객의 안전 및 출입 위규 분석<br>
                  <p>○ 개인 위치정보 보유기간 : 수집일로부터 1개월</p>

                  <div class="mb-1 d-flex">
                    1)&nbsp;
                    <div>
                      개인 위치정보 수집ㆍ이용ㆍ제공 사실확인 자료의 보유 근거 및 보유기간<br>
                      회사는 위치정보법 제16조 제2항에 근거하여 개인 위치정보 주체에 대한 위치정보 수집ㆍ이용ㆍ제공 사실확인 자료를 위치정보 시스템에 자동으로 기록하며, 1개월간 보관합니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    2)&nbsp;
                    <div>
                      개인 위치정보 파기 절차 및 방법<br>
                      회사는 개인 위치정보의 처리목적이 달성된 경우, 개인 위치정보를 재생이 불가능한 방법으로 안전하게 파기하고 있습니다. 전자적 파일 형태는 복구 및 재생이 불가능한 기술적인 방법으로 파기하며, 출력물 등은 분쇄하거나 소각하는 방식으로 파기합니다.
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    3)&nbsp;
                    <div>
                      개인 위치정보 제 3자 제공 및 통지 방법<br>
                      회사는 이용자의 사전 동의 없이 개인 위치정보를 제 3자에게 제공하지 않으며, 이용자가 지정한 제 3자에게 개인 위치정보를 제공하는 경우 매회 개인 위치정보 주체에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다.<br>
                      회사는 관련 법령에 의거해 개인 위치정보 제출 의무가 발생한 경우, 이용자의 생명이나 안전에 급박한 위험이 확인되어 이를 해소하기 위한 경우에 한하여 개인 위치정보를 제공합니다.<br>
                    </div>
                  </div>
                  <div class="mb-1 d-flex">
                    4)&nbsp;
                    <div>
                      개인 위치정보 책임자 지정<br>
                      회사의 개인 위치정보 책임자는 위 개인정보보호 책임자가 겸직하고 있으며, 자세한 사항은 "8. 개인정보보호 책임자 지정"을 참고하시기를 바랍니다.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              11.&nbsp;
              <div>
                권익침해에 대한 구제 방법<br>
                <div class="content_subtitle mt-2 mb-4">
                  <p>정보 주체는 개인정보 침해로 인한 구제를 받기 위하여 개인정보 분쟁조정위원회, 한국인터넷진흥원 개인 정보침해신고센터 등에 분쟁 해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보 침해의 신고, 상담에 대해서는 아래의 기관에 문의하시기를 바랍니다.</p>
                  
                  <div class="mb-1 d-flex">
                    <div>1)&nbsp;</div>
                    <div>개인정보 분쟁조정위원회 : (국번 없이) 1833-6972 (<a href="https://www.kopico.go.kr/" target="_blank">https://www.kopico.go.kr</a>)</div>
                  </div>
                  <div class="mb-1 d-flex">
                    <div>2)&nbsp;</div>
                    <div>개인 정보침해신고센터 : (국번 없이) 118 (<a href="https://privacy.kisa.or.kr/" target="_blank">https://privacy.kisa.or.kr</a>)</div>
                  </div>
                  <div class="mb-1 d-flex">
                    <div>3)&nbsp;</div>
                    <div>대검찰청 : (국번 없이) 1301 (<a href="https://www.spo.go.kr/" target="_blank">https://www.spo.go.kr</a>)</div>
                  </div>
                  <div class="mb-4 d-flex">
                    <div>4)&nbsp;</div>
                    <div>경찰청 : (국번 없이) 182 (<a href="https://ecrm.police.go.kr/" target="_blank">https://ecrm.cyber.go.kr</a>)</div>
                  </div>

                  <p>「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 무작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.</p>
                  <p>※ 행정심판에 대해 자세한 사항은 중앙행정심판위원회(<a href="https://www.simpan.go.kr/" target="_blank">https://www.simpan.go.kr</a>) 홈페이지를 참고하시기를 바랍니다.</p>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              12.&nbsp;
              <div>
                개인정보 처리 방침 변경<br>
                <div class="content_subtitle mt-2 mb-4">
                  <p>본 개인정보 처리 방침 내용의 추가, 삭제 및 수정이 있을 시에는 변경되는 내용을 시행하기 7일 전에 홈페이지를 통해 공지하도록 하겠습니다.</p>
                  공고 일자 : 2023년 05월 03일<br>
                  시행 일자 : 2023년 05월 03일<br>
                </div>
              </div>
            </div>
          </v-card-text>
        </div>

        <v-divider></v-divider>    
        <v-card-actions style="height:50px;">
          <v-spacer></v-spacer>
          <v-btn width="100" @click="dialog = false;" dark><v-icon>mdi-close</v-icon>닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-card>


    <!-- 영상정보처리기기방침 -->
    <v-card v-if="cPledgeId == 'A0008'" class="pa-4 pt-0 pb-2">
      <v-card flat>
        <v-card-title class="peldge_title pr-0 pl-0" id="A0008">
          <div class="red--text text--darken-2 peldge_title_text">영상정보 처리 기기 운영방침</div>
          <v-spacer></v-spacer>
          <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
        </v-card-title>
        <v-divider></v-divider>

        <div class="pledge_content">
          <v-card-text class="lineHeight2">
            <div class="content_subtitle">
              {{$store.state.CustomInfo.SiteNm}} 주식회사는 (이하 ‘회사’라 한다) 개인정보를 중요시하며, 관련 법규에 따라 영상정보처리기기 운영 및 관리방침을 통해 개인 영상정보 이용 및 관리를 알려드립니다.
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text class="lineHeight2">
            <div class="mb-1 d-flex">
              1.&nbsp;
              <div>
                영상정보처리기기의 설치 근거 및 목적
                <div class="content_subtitle mt-2 mb-4">
                  <p>회사는 개인정보 보호법 제25조 제1항을 준수하여 고객과 구성원의 안전 및 범죄예방, 시설물 보호 등을 목적으로 영상정보처리기기를 설치/운영하며 기타 세부 목적은 다음과 같습니다.</p>

                  <div class="mb-1 d-flex">
                    <div>1)&nbsp;</div>
                    <div>시설, 주차, 안전관리 및 화재 예방</div>
                  </div>
                  <div class="mb-1 d-flex">
                    <div>2)&nbsp;</div>
                    <div>인원, 차량의 출입 관리 및 통제</div>
                  </div>
                  <div class="mb-1 d-flex">
                    <div>3)&nbsp;</div>
                    <div>사업장 방호 및 도난 등 범죄예방</div>
                  </div>
                  <div class="mb-1 d-flex">
                    <div>4)&nbsp;</div>
                    <div>외부인 불법침입 방지</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              2.&nbsp;
              <div>
                영상정보처리기기 설치 장소
                <div class="content_subtitle mt-2 mb-4">
                  <p>회사는 관련법률에 의거하여 다음의 장소에 영상정보처리기기를 설치합니다.</p>
                  <div class="mb-1 d-flex">
                    <div>1)&nbsp;</div>
                    <div>공장에 인원 및 차량이 출입하는 주 출입구(사무실, 조정실 포함), 로비, 복도, 주차장 등 공공의 안전과 영업비밀 보호를 위한 보안 등이 요구되는 장소</div>
                  </div>
                  <div class="mb-1 d-flex">
                    <div>2)&nbsp;</div>
                    <div>사업장 외곽경계 담장 등 범죄 예방을 위한 장소</div>
                  </div>
                  <div class="mb-1 d-flex">
                    <div>3)&nbsp;</div>
                    <div>기타 보안, 방범, 안전상의 취약 우려 지역 등</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              3.&nbsp;
              <div>
                영상정보처리기기 설치, 운영
                <div class="content_subtitle mt-2 mb-4">
                  회사에서 설치, 운영 중인 영상정보처리기기는 안전과 방범 및 시설물 보호 등에 대한 구체적이고 실질적인 위험이 발생할 우려가 있는 경우에 한하여 설치/운영하고 있습니다. 설치 수량 및 위치는 아래와 같습니다.
                  <table class="type09 text-center mb-4">
                    <thead>
                      <tr>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>설치 위치 및 촬영 범위</td>
                        <td>설치대 수 (2022. 11. 01 기준)</td>
                      </tr>
                      <tr>
                        <td>{{$store.state.CustomInfo.SiteNm}} 영주 공장 외곽 및 주요 동선, 조정실 및 사무실 출입구, 기타 회사 보안 및 재산상 중요 위치</td>
                        <td>221대</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              4.&nbsp;
              <div>
                영상정보 보호 및 영상정보처리기기 관리/운영 책임
                <div class="content_subtitle mt-2 mb-4">
                  영상정보처리기기 및 영상정보와 관련한 문의는 각 지역 사업장별 실무 담당 부서로 문의하시기를 바랍니다.
                  {{$store.state.CustomInfo.SiteNm}} 영상정보처리기기 설치 및 운영 책임<br>
                  <table class="type09 text-center mb-8">
                    <thead>
                      <tr>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowspan="2">구분</td>
                        <td rowspan="2">용도</td>
                        <td rowspan="2">촬영 시간</td>
                        <td rowspan="2">영상보관 기간</td>
                        <td colspan="2">관리/운영 책임자</td>
                      </tr>
                      <tr>
                        <td>부서</td>
                        <td>연락처</td>
                      </tr>
                      <tr>
                        <td>{{$store.state.CustomInfo.SiteNm}} 영주 공장</td>
                        <td>시설 안전 보안</td>
                        <td>24시간</td>
                        <td>30일</td>
                        <td>IT 기획·보안팀</td>
                        <td>054-630-8126</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>


            <div class="mb-1 d-flex">
              5.&nbsp;
              <div>
                영상정보의 수집, 보호조치 및 처리 방법
                <div class="content_subtitle mt-2 mb-4">
                  <p>회사는 상기 1항에 설치목적 외 임의로 영상정보를 수집하거나 녹음기능을 사용하지 않으며 수집, 저장된 영상정보는 접근권한을 부여받은 자 이외의 타인의 접근이 일체 통제된 구역과 비밀번호와 잠금장치가 설치된 보안시스템으로 관리하고 있습니다.</p>
                  <p>회사는 영상정보처리기기를 통해 촬영, 수집된 영상정보를 대외비 이상으로 관리하고 있으며 임의 열람과 재생, 사외 반출을 금지하고 있습니다.</p>
                  <div>개인 영상정보의 목적 외 이용, 제 3자 제공, 열람 등 요구, 파기에 관한 사항을 기록, 관리하고 영상정보는 보관기간 만료 시 복원이 불가능하도록 영구삭제 됩니다.</div>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              6.&nbsp;
              <div>
                개인 영상정보의 확인, 삭제 요구 및 조치
                <div class="content_subtitle mt-2 mb-4">
                  <p>정보 주체인 개인의 영상정보에 관하여 열람 또는 확인, 삭제를 원하는 경우 언제든지 영상정보처리기기 관리책임자에게 요구하실 수 있습니다. 단, 정보 주체인 본인이 촬영된 영상정보와 명백히 정보 주체의 급박한 생명, 신체, 재산의 이익을 위하여 필요한 개인 영상정보에 한합니다.</p>
                  <p>회사는 정보 주체가 개인 영상정보에 관하여 열람 또는 삭제를 요청할 시 아래의 거부 경우를 제외하고 즉시 조치하겠습니다. </p>
                  <div class="mb-1 d-flex">
                    <div>1)&nbsp;</div>
                    <div>개인 영상정보의 보관기간이 경과되어 정보가 삭제된 경우</div>
                  </div>
                  <div class="mb-1 d-flex">
                    <div>2)&nbsp;</div>
                    <div>영상정보 열람 및 공개로 인한 타인의 사생활 침해가 우려되는 경우</div>
                  </div>
                  <div class="mb-1 d-flex">
                    <div>3)&nbsp;</div>
                    <div>범죄 수사, 공소 유지, 재판 수행 등에 중대한 지장을 초래하는 경우</div>
                  </div>
                  <div class="mb-4 d-flex">
                    <div>4)&nbsp;</div>
                    <div>기타 당사가 정보 주체의 열람, 확인 요구에 정당하게 거부할 만한 사유가 있는 경우</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-1 d-flex">
              7.&nbsp;
              <div>
                영상정보처리기기 운영, 관리방침의 변경 공지
                <div class="content_subtitle mt-2">
                  본 영상처리기기 운영, 관리 방침은 법령, 정책 또는 보안 기술의 변경에 따라 내용의 추가, 삭제 및 수정이 있을 시 지체 없이 이를 당사 홈페이지를 통해 변경 사유 및 내용 등을 공지하도록 하겠습니다.
                </div>
              </div>
            </div>
          </v-card-text>
        </div>

        <v-divider></v-divider>    
        <v-card-actions class="pr-0">
          <v-spacer></v-spacer>
          <v-btn width="100" @click="dialog = false;" dark><v-icon>mdi-close</v-icon>닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-card>    
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";

export default {
  components: {
  },
  data: () => ({
    sNowYear:"",
    sNowMounth : "",
    sNowDate : "",
    cPledgeId: "",
    dialog : false,
    oSecPeldge : [
      {cId : "1.",cComment : "회사에 출입하면서 알게 된 회사의 정보를 출입 기간(또는 프로젝트 기간)뿐 아니라 출입이 종료된 이후에도  타인에게 누설하지 않겠으며, 출입 기간 중 제공 받은 정보 또는 자료는 출입이 종료될 경우 모두 반납하겠습니다. " },
      {cId : "2.",cComment : "회사의 허가 없이 회사의 물품 또는 자료를 임의로 회사 밖으로 반출하지 않겠습니다." },
      {cId : "3.",cComment : "업무와 무관한 정보를 수집하거나 이와 유사한 행위를 하지 않겠습니다." },
      {cId : "4.",cComment : "정당하지 않은 방법으로 취득한 제 3자의 영업비밀을 회사 구성원에게 제공하지 않겠습니다." },
      {cId : "5.",cComment : "정당하게 취득한 제 3자의 영업비밀이라 하더라도 회사에 제공할 경우 회사가 정한 적법한 방법과 절차를 준수하겠습니다." },
      {cId : "6.",cComment : "출입을 허가받은 건물 또는 장소 이외에는 출입하지 않겠습니다." },
      {cId : "7.",cComment : "업무와 관련하여 회사의 전산시스템 사용을 허가받은 경우 그 권한을 타인과 공유하지 않겠습니다. (전산시스템 아이디 및 패스워드 공유 금지)" },
      {cId : "8.",cComment : "업무와 관련하여 전산시스템을 사용할 경우 회사의 보안정책을 준수하고, 필요시 통신망 이용에 따라 전송되는 정보의 모니터링 및 통제를 할 수 있음에 동의합니다." },
      {cId : "9.",cComment : "회사의 보안정책을 준수할 뿐만 아니라, 이에 대한 위반사례를 발견하였을 경우에는 지체 없이 보안 담당 부서에 신고하겠습니다." },
      {cId : "10.",cComment : "회사 출입과 관련하여 허위 정보 기재 또는 제공, 허위 서류 제출 등 기만행위를 하지 않겠습니다." },
      {cId : "11.",cComment : "업무와 무관한 물품 또는 반입을 금지하는 물품을 회사 내부로 반입하지 않겠습니다." },
      {cId : "12.",cComment : "회사가 발급한 출입증을 육안으로 식별이 가능하도록 노출하여 사업장 내에서는 항상 패용하겠으며 출입증을 타인에게 대여하거나 위·변조하지 않겠으며 기간이 만료된 경우 즉시 반납하겠습니다." },
      {cId : "13.",cComment : "출입을 허가받은 기간 중이라도 프로젝트 종료 등으로 출입 사유가 종료된 경우 출입증을 즉시 반납하겠으며, 출입증을 분실한 경우 24시간 이내에, 회사에 신고하겠습니다. 만약 출입증 미반납 또는 분실 미신고에 따른 회사의 피해 발생 시 일체의 피해를 보상하겠습니다." },
      {cId : "14.",cComment : "회사 내에서 회사의 허가 없이 임의로 사진 촬영을 하지 않겠습니다." },
      {cId : "15.",cComment : "회사의 건물 내에서 허가 없이 경영상 또는 기술상의 정보를 녹음하거나 이와 유사한 행위를 하지 않겠습니다." },
      {cId : "16.",cComment : "회사 내에서 회사의 허가 없이 유인물(판촉물) 배포, 상행위, 모금행위, 선동행위 등을 하지 않겠습니다." },
      {cId : "17.",cComment : "회사 보안주관부서의 정당한 보안 업무 수행에 적극 협조하겠습니다." },
      {cId : "18.",cComment : "회사 보안요원의 정당한 출입 통제 및 보안 검색 업무에 적극 협조하겠습니다." },
      {cId : "19.",cComment : "회사 시설물을 보호하겠으며 시설물을 파손 또는 손괴하였을 경우 손해배상 하겠습니다." },
    ],
  }),
  
  mounted () {
  },
  
  computed: {
    ...mapState(["HomepageURL"]),
  },

  methods: {    
    ShowDialog(cPledgeId, date){
      this.dialog = true;
      this.cPledgeId = cPledgeId;
      this.sNowYear = "";
      this.sNowMounth = "";
      this.sNowDate = "";

      console.log(date);

      if (date != "") {
        this.sNowYear = date.substring(0,4);
        this.sNowMounth = date.substring(5,7);
        this.sNowDate = date.substring(8,10);
      }

      setTimeout(() => {
        var element =  document.getElementById(this.cPledgeId);
        element.scrollIntoView({behavior : "smooth"})
      }, 10);
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "../publishing/visit.scss";

  .lineHeight4{
    line-height: 180%
  }
  .sec_box{
    margin: auto;        
    text-align: center;
    box-shadow: 0px 0px 1px 1px #f3f3f3; 
  }

  table.type09 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type09 thead th {
    padding-top: 10px;
    padding-bottom: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 2px solid rgb(141, 141, 141);
    // width: 25%;
  }
  table.type09 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type09 td {
    width: 350px;
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }

  table.type08 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type08 thead th {
    padding-top: 10px;
    padding-bottom: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
  }
  table.type08 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type08 td {
    width: 350px;
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }
  table.type08 tbody tr {
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }

  // .education_title {
  //   word-break: keep-all;

  //   @media screen and (min-width: 1065px) {
  //     font-size: 2.125rem;
  //     font-weight: 400;
  //     height : 90px;

  //     :deep(img) {
  //       height : 45px;
  //     }
  //   }

  //   @media screen and (min-width: 600px) and (max-width: 1064px){
  //     font-size: 1.5rem;
  //     font-weight: 500;
  //     height : 70px;

  //     :deep(img) {
  //       height : 35px;
  //     }
  //   }

  //   @media screen and (max-width: 601px) {
  //     padding : 0px;
  //     font-size: 0.9rem;
  //     font-weight: 500;
  //     height : 50px;

  //     :deep(img) {
  //       height : 20px;
  //     }
  //   }
  // }
  
  .pledge_content {
    overflow:auto;
    word-break: keep-all;
    @media screen and (min-width: 1065px) {
      height:calc(90vh - 160px);

      :deep(.v-card__text) {
        letter-spacing: .0125rem;
        font-size: 1.25rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .009375rem;
        font-size: 1rem;
        font-weight: 400;
        padding-right: 25px;
      }
    }

    @media screen and (min-width: 600px) and (max-width: 1064px){
      height:calc(90vh - 135px);

      :deep(.v-card__text) {
        // background-color : blue;
        letter-spacing: .01rem;
        font-size: 1rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        // background-color : green;
        letter-spacing: .009375rem;
        font-size: 0.9rem;
        font-weight: 400;
        padding-right: 22px;
      }
    }

    @media screen and (max-width: 601px) {
      height:calc(90vh - 150px);
      :deep(.v-card__text) {
        letter-spacing: .0075rem;
        font-size: 0.9rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .007rem;
        font-size: 0.8rem;
        font-weight: 400;
        padding-right: 16px;
      }
    }
  }
</style>
